// @flow

import { connect } from 'react-redux';
import { fetchContentful } from 'client/actions/contentful';
import FinanceGuidePage from './financeGuidePage';

const mapStateToProps: Object = state => ({
  contentfulData: state.contentfulData,
  translations: state.translations,
});

export default connect(mapStateToProps, { fetchContentful })(FinanceGuidePage);
